const translateUnit = (unit, count, t) => {
  if (unit === 'DAY') return t('REPORT.DURATION.DAY', { count });
  if (unit === 'HOUR') return t('REPORT.DURATION.HOUR', { count });
  if (unit === 'MINUTE') return t('REPORT.DURATION.MINUTE', { count });
  return t('REPORT.DURATION.SECOND', { count });
};

export const formatReportDuration = (value, t) => {
  const totalSeconds = Math.max(0, Math.round(Number(value) || 0));
  const units = [
    ['DAY', 86400],
    ['HOUR', 3600],
    ['MINUTE', 60],
    ['SECOND', 1],
  ];
  let remainder = totalSeconds;
  const parts = [];

  units.forEach(([unit, seconds]) => {
    if (parts.length >= 2) return;
    const count = Math.floor(remainder / seconds);
    if (count > 0 || (unit === 'SECOND' && parts.length === 0)) {
      parts.push(translateUnit(unit, count, t));
      remainder %= seconds;
    }
  });

  return parts.join('').trim();
};
